import { render, staticRenderFns } from "./VStakeholderForm.vue?vue&type=template&id=8fef3d6a&"
import script from "./VStakeholderForm.vue?vue&type=script&lang=js&"
export * from "./VStakeholderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports